// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"0adab7a8","250":"bff554a0","253":"5ec25a71","440":"20ba39c9","488":"cd5180d6","823":"363a6bd4"}[chunkId] + ".chunk.css";
};